import { EntityAction, DefaultPersistenceResultHandler } from '@ngrx/data';
import { Action } from '@ngrx/store';
import { Injectable } from '@angular/core';

@Injectable()
export class PlPersistenceResultHandler extends DefaultPersistenceResultHandler {
  override handleSuccess(originalAction: EntityAction): (data: any) => Action {
    const actionHandler = super.handleSuccess(originalAction);
    // return a factory to get a data handler to
    // parse data from DataService and save to action.payload
    return (data: any) => {
      const action = actionHandler.call(this, data);
      if (action && data && data.results) {
        (action as any).payload.data = data.results;
        (action as any).payload.count = data.count;
      }
      return action;
    };
  }
}
